import { route } from 'navi';
import { DepositModal } from '.';

export default route((request) => {
  let currency: string | undefined;

  if (request.params != null && request.params.currency != null) {
    currency = request.params.currency;
  }

  return {
    title: 'Redirect...',
    view: <DepositModal currency={currency} />,
  };
});
